import axios from 'axios'
import { getCookieByName, clearAllCookies } from '../../utils'

// URL resolvida por ambiente: prioriza variável explícita, senão usa build stage
const OPEN_FINANCE_URL =
    process.env.REACT_APP_OPEN_FINANCE_URL ||
    (process.env.REACT_APP_BUILD_STAGE === 'homolog'
        ? 'http://vps1.easygestor.com:8001'
        : 'https://cron-jobs-open-finance-api.pc9f6u.easypanel.host')

export const openFinanceUserApi = axios.create({
    baseURL: OPEN_FINANCE_URL,
    headers: {
        "Content-Type": "application/json",
    }
})

async function refreshToken() {
    return new Promise((resolve, reject) => {
        const refresh = getCookieByName("refresh")
        const API_URL = require('../../utils/config').getConfig().api.baseUrl;
        const data = { refresh: refresh }
        const url = `${API_URL}/api/token/refresh/`
        axios
            .post(url, data)
            .then(response => {
                const date = new Date();
                date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
                const expires = `expires=${date.toUTCString()}`
                document.cookie = `access=${response.data.access}; path=/;${expires}`
                resolve(response.data.access)
            })
            .catch(error => {
                if (error.response) {
                    clearAllCookies()
                    window.localStorage.clear()
                    window.location.href = "/"
                }
                reject(error)
            })
    })
}

openFinanceUserApi.interceptors.request.use(config => {
    const access = getCookieByName("access")
    const branchOwnerId = getCookieByName("branch_owner_id")
    
    if (access) {
        config.headers["Authorization"] = `Bearer ${access}`
    }
    
    if (branchOwnerId) {
        config.headers["x-company-id"] = branchOwnerId
    }
    return config
}, error => Promise.reject(error))

openFinanceUserApi.interceptors.response.use(response => {
    return response.data
}, async error => {
    const originalRequest = error.config;
    if (error.response) {
        const { status } = error.response
        if (status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                const access = await refreshToken();
                originalRequest.headers["Authorization"] = `Bearer ${access}`
                return openFinanceUserApi(originalRequest);
            } catch (err) {
                return Promise.reject(err);
            }
        }
    }
    return Promise.reject(error.response ? error.response.data : error);
})

export function getChartOfAccounts() {
    return openFinanceUserApi.get('/chart-of-accounts/')
}

export function createOpenFinanceTransaction(data) {
    return openFinanceUserApi.post('/transactions/', data)
}



// WEBPACK FOOTER //
// ./src/api/openFinance/index.js